import { Button } from "@growtherapy/sprout-ui";

export enum NoAccessVariant {
  Camera = "camera",
  Microphone = "microphone",
}

export function NoAccessButton({ onClick }: { onClick: () => void }) {
  return (
    <Button use="link" onClick={onClick} className="px-0 text-neutral-800">
      Learn how to allow access.
    </Button>
  );
}
